"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hexToByteArray = hexToByteArray;
function hexToByteArray(h) {
  if (!/^(0x)?([0-9a-fA-F][0-9a-fA-F])*$/.test(h)) {
    throw new Error("Invalid hex string!");
  }
  if (h.startsWith("0x")) {
    h = h.slice(2);
  }
  const array = [];
  while (h.length >= 2) {
    array.push(parseInt(h.slice(0, 2), 16));
    h = h.slice(2);
  }
  return array;
}
//# sourceMappingURL=utils.js.map